export enum ArticleGroups {
    pelvis = "pelvis",
    hand = "hand",
    foot = "foot",
    clothing = "clothing",
    bike = "bike_profile",
}

export const ArticleGroupsMatchingWithHasura: { [key: string]: string } = {
    pelvis: "pelvis",
    hand: "hand",
    foot: "foot",
    clothing: "clothing",
    bike_profile: "bike",
}


export enum BicycleTypeEnum {
    // Trial & BMX, MTB Dirt & Downhill are removed (Max Holz 2026-04-28)
    // trialBmx = "trial_bmx",
    // mountainBikeDownhill = "mtb_downhill",
    cityComfort = "city_comfort",
    trekkingComfort = "trekking_comfort",
    trekkingCross = "trekking_cross",
    mountainBikeAllMountain = "mtb_all_mountain",
    mountainBikeMarathon = "mtb_marathon",
    mountainBikeCrossCountry = "mtb_xc",
    gravel = "gravel",
    racingBike = "racing_bike",
    roadRace = "road_race",
    triathlon = "triathlon_bike",
}

export enum EBike {
    eBikeYes = "ebike_yes",
    eBikeNo = "ebike_no",
}

export enum RidingDuration {
    lessThan45Minutes = "lessThan45min",
    lessThan2Hours = "between45minAnd2h",
    moreThan2Hours = "moreThan2h",
}

export enum RidingFrequency {
    severalTimesPerWeek = "several_times_a_week",
    oncePerWeek = "one_time_a_week",
    everyTwoWeeks = "every_two_weeks",
    everyFourWeeks = "every_four_weeks",
}

export enum FootPosition {
    vFootPosition = "v",
    straightFootPosition = "straight",
}

export enum FootProblems {
    numbToes = "numb_toes",
    kneeDiscomfort = "knee_discomfort",
}

export enum FootType {
    archesFootType = "arches_foot",
    normalFootType = "normal",
    archedFootType = "arched_foot",
    flatFoodType = "flat_foot",
}

export enum HandProblems {
    numbThumbAndIndexAndMiddleFinger = "numb_thumb_index_and_middle_finger",
    numbLittleAndRingFinger = "numb_little_and_ring_finger",
    wristProblem = "wrist",
    upperBackProblem = "upper_back",
}

export enum LegAxis {
    oLegs = "o_legs",
    straightLegs = "straight_legs",
    xLegs = "x_legs",
}

export enum PelvicProblems {
    numbness = "numbness",
    sitBonesProblem = "sitbones",
    coccyx = "coccyx",
    pubicBoneProblem = "pubic_bone",
    prostateProblem = "prostate",
    lowerBackProblem = "lower_back",
    heatSweatProblem = "heat_sweat",
    pelvicMisalignment = "pelvic_malalignment",
}

export enum SeatPosition {
    triathlon = "triathlon",
    sportive = "sportive",
    moderate = "moderate",
    slightlyBent = "slightly_bent",
    upright = "upright",
}

export enum Sex {
    male = "male",
    female = "female",
    diverse = "diverse",
}
